import React from "react";

const CustomTextArea = (props) => {
    return (
        <div>
            <textarea id={props.id} placeholder={props.placeholder} rows="3"
                   onChange={props.onChange} required={props.required}
                   className="outline-none input-border p-1 br-4 w-100" value={props.value}/>
            {props.error && < div className="fc-red fs-14 py-1">{props.error}</div>}
        </div>
    );
}

export default CustomTextArea;
